import { AlertCircle, RefreshCw } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface UpdateBannerProps {
  onReload: () => void;
}

export const UpdateBanner = ({ onReload }: UpdateBannerProps) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 p-4 bg-blue-50 border-b-2 border-blue-200 shadow-lg">
      <Alert className="max-w-4xl mx-auto bg-white border-blue-300">
        <AlertCircle className="h-5 w-5 text-blue-600" />
        <AlertDescription className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div>
              <p className="font-semibold text-blue-900">Νέα έκδοση διαθέσιμη!</p>
              <p className="text-sm text-blue-700">
                Μια ενημερωμένη έκδοση της εφαρμογής είναι διαθέσιμη. Παρακαλώ ανανεώστε τη σελίδα.
              </p>
            </div>
          </div>
          <Button 
            onClick={onReload}
            className="bg-blue-600 hover:bg-blue-700 text-white ml-4"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Ανανέωση
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
};
